import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getMotorCityStart,
  getMotorCitySuccess,
  getMotorCityFailure,
} from "../reducers/getMotorCityReducer";
import axios from "axios";
import Cookies from "js-cookie";

export const getMotorCity = createAsyncThunk(
  "getMotorCity",
  async (_, thunkAPI) => {
    try {
      thunkAPI.dispatch(getMotorCityStart());
      const token = Cookies.get("token");

      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}api/Health/GetCity`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const responseData = await response;

      thunkAPI.dispatch(getMotorCitySuccess(responseData?.data?.result));

      return responseData;
    } catch (error) {
      thunkAPI.dispatch(getMotorCityFailure(error.response.data.Message));

      throw error;
    }
  }
);
